import { render, staticRenderFns } from "./MediaLibraryCard.vue?vue&type=template&id=3a787092&scoped=true&"
import script from "./MediaLibraryCard.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a787092",
  null
  
)

export default component.exports